import React, {useState} from 'react';

import styles from './Counter.module.scss';

type CounterProps = {
    className?: string;
    onClearTimeOut: () => void;
    duration?: string | number;
    phase?: number;
};

const Counter = ({className, onClearTimeOut, duration = 5, phase}: CounterProps) => {
    const [timer, setTimer] = useState(typeof duration === 'string' ? parseInt(duration, 10) : duration);

    const clearTimer = () => {
        setTimer(-1);
        onClearTimeOut();
    };

    React.useEffect(() => {
        const TimerInt =
            timer > 0 &&
            setInterval(() => {
                setTimer((time: number) => time - 1);
                if (timer <= 0) clearTimer();
            }, 1000);

        if (timer === 0) {
            clearTimer();
        }

        return () => {
            clearInterval(TimerInt);
        };
    }, [timer]);

    return (
        timer > 0 &&
        phase !== 3 && (
            <div className={[styles.counter, className].join(' ')}>
                <svg
                    onClick={() => setTimer(-1)}
                    className={styles.counter_icon}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g opacity="0.3">
                        <rect width="16" height="16" rx="8" transform="matrix(-1 0 0 1 16 0)" fill="black" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5.31409 5.53333C5.492 5.35543 5.78044 5.35543 5.95835 5.53333L7.8911 7.46609L9.82379 5.53339C10.0017 5.35549 10.2901 5.35549 10.468 5.53339C10.646 5.7113 10.646 5.99974 10.468 6.17765L8.53536 8.11034L10.4681 10.0431C10.646 10.221 10.646 10.5095 10.4681 10.6874C10.2902 10.8653 10.0018 10.8653 9.82388 10.6874L7.8911 8.7546L5.95827 10.6874C5.78036 10.8653 5.49192 10.8653 5.31401 10.6874C5.1361 10.5095 5.1361 10.2211 5.31401 10.0432L7.24685 8.11034L5.31409 6.17759C5.13619 5.99968 5.13619 5.71124 5.31409 5.53333Z"
                            fill="white"
                        />
                    </g>
                </svg>
                <span className={styles.counter_text}>{timer} seconds</span>
                <span className={styles.counter_subText}>to next screen</span>
            </div>
        )
    );
};

export default Counter;
